import { render } from "./LeftMenuPanel.vue?vue&type=template&id=179227d3&scoped=true&ts=true"
import script from "./LeftMenuPanel.vue?vue&type=script&lang=ts"
export * from "./LeftMenuPanel.vue?vue&type=script&lang=ts"

import "./LeftMenuPanel.vue?vue&type=style&index=0&id=179227d3&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179227d3"]])

export default __exports__